export default {
  type: 'boolean',
  label: 'Sim/Não',
  shape: 'circle',
}